/** @file 红包 语言配置 */
const zhCN = {
  redEnvelope: {
    singleChoice: '单选',
    multiChoice: '多选',
    judgement: '判断',
    inputPswPlaceholder: '输口令，领红包',
    expired: '已失效',
    unfortunately: '很遗憾',
    expired2: '红包已过期',
    robbed: '红包被抢光了',
    congratulations: '恭喜你获得',
    accept: '收下',
    withdrawMoney: '可从直播间"更多-提现"，将红包提现至微信',
    close: '关闭',
    typeNormal: '普通红包',
    typePassword: '口令红包',
    typeRain: '红包雨',
    typeQuestion: '答题红包',
    typeAlipayPassword: '支付宝口令红包',
    receive: '领取红包',
    received: '已领取',
    finished: '已领完',
    expired3: '已失效',
    senderTip1: '由',
    senderTip2: '发起',
    scanToWeChat: '微信扫一扫，参与红包活动',
    pswEmpty: '口令不能为空',
    pswError: '口令错误，请重新输入',
    pwsPendantTip: '口令红包即将来袭',
    normalPendantTip: '普通红包即将来袭',
    rainPendantTip: '红包雨即将来袭',
    questionPendantTip: '答题红包即将来袭',
    pswTitle: '输入口令，领取红包',
    qnTitle: '参与答题，领取红包',
    withdrawBtn: '提现',
    pointRecordBtn: '领取记录',
    totalAmount: '总金额',
    unit: '元',
    alipayPwdRnGetTip1: '前往支付宝搜索“红包”',
    alipayPwdRnGetTip2: '输入口令立抢现金红包',
    clickCopyPwd: '点击复制口令',
    copySucceeded: '复制成功',
    question: '问题：',
    answerLabel: '答案：',
    answerCorrectTip: '答对{num}题可瓜分红包',
    questionTip2: '已答对 {num} 题',
    questionBtn1: '确认选项',
    questionBtn2: '下一题',
    answerTip1: '恭喜你答对了！',
    answerTip2: '正确答案是',
    answerTip3: '你的答案是',
    answerWrong: '回答错误！',
    open: '立即开红包',
    notEligibleTip1: '您不满足领取红包的资格',
    notEligibleTip2: '共答对{rightCount}题，答对{correctAnswer}题才可瓜分红包'
  },
  redpackRain: {
    send1: '由',
    send2: '发起',
    openInWechat: '请在微信端打开',
    copyLink: '复制直播间链接',
  }
};

const en = {
  redEnvelope: {
    singleChoice: 'Single Choice',
    multiChoice: 'Multiple Choice',
    judgement: 'Judgement',
    askQuestion: 'Question',
    inputPswPlaceholder: 'Enter the password and receive the red envelope',
    expired: 'expired',
    unfortunately: 'unfortunately',
    expired2: 'The red envelope has expired',
    robbed: 'The red envelopes were robbed',
    congratulations: 'Congratulations on getting',
    accept: 'Accept',
    withdrawMoney: 'You can withdraw the red envelopes to WeChat from the "More-Withdraw" from the live broadcast room',
    close: 'close',
    typeNormal: 'Ordinary red envelope',
    typePassword: 'Password red envelope',
    typeRain: 'Red envelope rain',
    typeQuestion: 'Question red envelope',
    typeAlipayPassword: 'Alipay password red envelope',
    receive: 'Receive red envelope',
    received: 'Received',
    finished: 'Finished',
    expired3: 'Expired',
    senderTip1: 'Initiated by',
    senderTip2: '',
    scanToWeChat: 'Scan WeChat to participate in the red envelope activity',
    pswEmpty: 'Password cannot be empty',
    pswError: 'The password is wrong, please re-enter',
    pwsPendantTip: 'The password red envelope is coming',
    normalPendantTip: 'Ordinary red envelope is coming',
    rainPendantTip: 'Red envelope rain is coming',
    questionPendantTip: '答题红包即将来袭',
    pswTitle: 'Enter the password and receive the red envelope',
    qnTitle: 'Answer red envelope',
    withdrawBtn: 'Withdraw',
    pointRecordBtn: 'Record',
    totalAmount: 'Total amount',
    unit: 'yuan',
    alipayPwdRnGetTip1: 'Go to Alipay to search for "red envelope"',
    alipayPwdRnGetTip2: 'Enter password to rob cash red envelope',
    clickCopyPwd: 'Click Copy Password',
    copySucceeded: 'Copy succeeded',
    question: 'question:',
    answerLabel: 'Answer:',
    answerCorrectTip: 'Correct {num} questions, share the red envelope',
    questionBtn1: 'confirm option',
    questionBtn2: 'next question',
    questionTip2: 'Correct {num}',
    answerTip1: 'Congratulations, you got it！',
    answerTip2: 'The correct answer is',
    answerTip3: 'Your answer is',
    answerWrong: 'wrong answer!',
    open: 'open',
    notEligibleTip1: 'You are not eligible to receive the bonus',
    notEligibleTip2: 'Answer {rightCount} of {correctAnswer} questions correctly, you can get a red envelope'
  },
  redpackRain: {
    send1: 'Sent by',
    send2: '',
    openInWechat: 'Please open it in wechat',
    copyLink: 'Copy live room link',
  }
};

export default {
  zh_CN: zhCN,
  en,
};
